import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { NCampaignTracking } from './campaign-tracking.namespace';

ICmsContentService.registerConfig({
    id: NCampaignTracking.CMS_CONFIG,
    name: 'Campaign Tracking configuration',
    fields: [
        <NICmsContentField.INumberField>{
            key: 'expiration',
            type: NICmsContentField.EFieldType.number,
            title: 'Expiration Time',
            description: 'in days'
        }
    ]
});
